import React, {useEffect, useState} from "react";
import {Redirect} from "react-router-dom";
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    Col,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Row
} from "reactstrap";
import businessHelper from "../../helpers/BusinessHelper";
import businessApiService from "../../api/business-api-service";
import lsHelpers from "../../helpers/LsHelper";
import {useObservable} from "../../components/utils/observable/observableHook";
import {localeService} from "../../components/utils/observable/services";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import ErrorModal from "../../components/Alerts/ErrorModal";
import {RotateCircleLoading} from "react-loadingg";
import LoadingOverlay from "react-loading-overlay";
import LanguagePanel from "../../components/utils/LanguagePanel";
import ClientAppComponent from "../../components/Alerts/ClientAppComponent";
import localeHelpers from "../../helpers/LocaleHelper";
import VerifiedModal from "../../components/Alerts/VerifiedModal";
import clientHelper from "../../helpers/ClientHelper";
import AppModal from "../../components/Alerts/AppModal";
import {isMobile} from 'react-device-detect';
import appleLogo from 'assets/img/icons/common/apple.svg'
import androidLogo from "assets/img/icons/common/android.svg"

let commonStrings = new LocalizedStrings(common_strings);

const Login = (props) => {

    const locale = useObservable(localeService.locale);

    const [accountType, setAccountType] = useState("b");
    const [error, setError] = useState(null);
    const [showError, setShowError] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [showVerifiedModal, setShowVerified] = useState(false);
    const [toDashboard, setToDashboard] = useState(false);
    const [toDiscover, setToDiscover] = useState(false);
    const [toBusiness, setToBusiness] = useState(false);
    const [toPasswordReset, setToPasswordReset] = useState(false);
    const [toRegister, setToRegister] = useState(false);
    const [showMobile, setShowMobile] = useState(false);
    const [validation, setValidation] = useState({
        email: true,
        password: true,
    });

    const [appLink, setAppLink] = useState(null);

    const [formData, setFormData] = useState({email: '', password: ''});

    useEffect(() => {
        setTimeout(function () {
            checkVerificationRequest();
        }, 300);
    }, [])

    function getBusiness(token) {
        setLoading(true)
        businessApiService.current()
            .then(res => {
                setLoading(false)
                businessHelper.saveUserSession(res)
                if (res.current && res.current.locale && res.current.locale.length > 1) {
                    const newLocale = res.current.locale.substring(0, 2).toLowerCase();
                    if (localeHelpers.isWhitelistedLocale(newLocale)) {
                        localeHelpers.saveLocaleLocally(newLocale)
                        localeService.setLocale(newLocale)
                    }
                }

                setToDashboard(true)
            })
            .catch((e) => {
                handleNetworkError(e)
            });
    }

    function checkVerificationRequest() {
        const query = new URLSearchParams(props.location.search);
        if (query && query.get('verification') === 'true') {
            const loc = query.get('locale')
            if (loc) onLanguageChanged(loc.substring(0, 2))
            verifyUser(query.get('email'), loc)
        } else if (query && query.get('locale')) {
            const loc = query.get('locale')
            if (loc) onLanguageChanged(loc.substring(0, 2))
            if (isMobile) setShowMobile(true)
        } else if (query && query.get('tkn')) {
            const token = query.get('tkn')
            setShowMobile(false)
            localStorage.setItem('at', token)
            getBusiness()
        } else {
            if (isMobile) setShowMobile(true)
        }

    }

    const saveUserSession = (data) => {
        businessHelper.saveUserSession(data);
        lsHelpers.createDatesRecord();
    };

    function showIsClientModal() {
        alert(commonStrings.client_account_warning)
    }

    function login() {
        setLoading(true)
        businessApiService.login(formData.email, formData.password, localeHelpers.currentLocale())
            .then(res => {
                setLoading(false)
                saveUserSession(res);
                setToDashboard(true)
            })
            .catch((e) => {
                handleNetworkError(e)
            });
    }

    function handleNetworkError(e) {
        setError(e);
        setShowError(true);
        setLoading(false);
    }

    function handleChange(event) {
        let newValue = event.target.value;

        const f = formData;

        if (event.target.id === 'input-email') {
            f.email = newValue;
        } else if (event.target.id === 'input-password') {
            f.password = newValue;
        }

        setFormData(f);
    }

    function handleSubmit(event) {
        event.preventDefault();
        login();
    }

    function businessButtonColor() {
        return accountType === "b" ? "yellowopen" : "secondary";
    }

    function clientButtonColor() {
        return accountType === "c" ? "yellowopen" : "secondary";
    }

    function setType(e, type) {
        e.preventDefault();
        setAccountType(type);

        if (!isMobile && type === 'c') {
            window.open('https://clientopen.com', 'blank')
        }
    }

    localize();

    if (toDashboard === true) {
        return <Redirect from="*" to="/admin/index"/>
    }

    if (toBusiness == true) {
        return <Redirect from="*" to="/client/business"/>
    }

    if (toDiscover == true) {
        return <Redirect from="*" to="/client/discover"/>
    }

    if (toRegister === true) {
        return <Redirect from="*" to="/auth/register"/>
    }

    if (toPasswordReset === true) {
        return <Redirect from="*" to="/auth/password_reset"/>
    }

    function toggleErrorModal() {
        setError(null);
        setShowError(false);
    }

    function onLanguageChanged(loc) {
        localeHelpers.saveLocaleLocally(loc);
        localeService.setLocale(loc);

        const calcRequestEvent = new CustomEvent('language_changed', {
            detail: {
                l: loc
            }
        })
        window.dispatchEvent(calcRequestEvent)
    }

    function toggleVerifiedModal() {
        setShowVerified(!showVerifiedModal)
    }

    function renderVerifiedModal() {
        return <VerifiedModal toggleVerifiedModal={toggleVerifiedModal}
                              showVerifiedModal={showVerifiedModal}
                              appLink={appLink}
        />
    }

    function downloadApp(e) {
        e.preventDefault();
        // window.location.replace("https://0zlz8.app.link/mId9S8KAghb")
        setShowMobile(true)
    }

    const toggleMobileModal = () => {
        setShowMobile(!showMobile)
    };

    return (
        <>
            {showError &&
                <ErrorModal showError={showError} error={error}
                            toggleErrorModal={toggleErrorModal}/>
            }

            {showVerifiedModal === true &&
                renderVerifiedModal()
            }

            {showMobile &&
                <AppModal toggleAppModal={toggleMobileModal} showAppModal={showMobile}/>
            }

            <Col lg="5" md="7" className="mt--100">
                <LoadingOverlay
                    active={isLoading}
                    spinner={<RotateCircleLoading color="white"/>}
                    text=''
                >
                    <Card className="bg-secondary shadow border-0">
                        <Row className="align-content-center"
                             style={{marginTop: "-50px", marginLeft: "6px"}}>
                            <LanguagePanel onResult={onLanguageChanged}/>
                        </Row>

                        <CardBody className="px-5 py-5">

                            <Row className="align-content-center text-center mb-3">
                                <Col>
                                    <Button
                                        color={businessButtonColor()} style={{width: "100%"}}
                                        onClick={e => setType(e, "b")}
                                    >
                                        {commonStrings.type_business}
                                    </Button>
                                </Col>
                                <Col>
                                    <Button
                                        color={clientButtonColor()} style={{width: "100%"}}
                                        onClick={e => setType(e, "c")}
                                    >
                                        {commonStrings.type_client}
                                    </Button>
                                </Col>
                            </Row>

                            {accountType == "b" &&
                                <Row className="mb-3">
                                    <Col>
                                        <Button style={{width: "100%", padding: 6}} onClick={e => downloadApp(e)}>
                                <span className="btn-inner--icon">
                                    <img
                                        style={{width: 20}}
                                        alt="..."
                                        src={appleLogo}
                                    />
                                </span>

                                            <span className="btn-inner--icon">
                                    <img
                                        style={{width: 20}}
                                        alt="android"
                                        src={androidLogo}
                                    />
                                </span>

                                        </Button>
                                    </Col>
                                </Row>
                            }

                            {/*<div className="text-center text-muted mb-4">*/}
                            {/*    <small>{commonStrings.sign_in_expl}</small>*/}
                            {/*</div>*/}
                            {/*{accountType == "b" || accountType == "c" ?*/}
                            {accountType == "b" ?
                                (<Form role="form" onSubmit={e => handleSubmit(e)}>
                                    <FormGroup className="mb-3">
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-email-83"/>
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input placeholder={commonStrings.email} type="email"
                                                   autoComplete="new-email"
                                                   id="input-email" onChange={handleChange}/>
                                        </InputGroup>
                                    </FormGroup>
                                    <FormGroup>
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-lock-circle-open"/>
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input placeholder={commonStrings.password} type="password"
                                                   autoComplete="new-password"
                                                   id="input-password" onChange={handleChange}/>
                                        </InputGroup>
                                    </FormGroup>
                                    <div className="text-center">
                                        <Button className="my-4" color="yellowopen" type="submit"
                                        >
                                            {commonStrings.login}
                                        </Button>
                                    </div>
                                </Form>)
                                : (<ClientAppComponent/>)
                            }
                        </CardBody>
                    </Card>
                    <Row className="mt-3">
                        <Col xs="6">
                            <a
                                className="text-light"
                                href="#pablo"
                                onClick={e => goToPasswordReset(e)}
                            >
                                <small>{commonStrings.forgot_password}</small>
                            </a>
                        </Col>
                        <Col className="text-right" xs="6">
                            <a
                                className="text-light"
                                href="#pablo"
                                onClick={e => goToRegister(e)}
                            >
                                <small>{commonStrings.create_account}</small>
                            </a>
                        </Col>
                    </Row>
                </LoadingOverlay>
            </Col>
        </>
    );

    function goToPasswordReset(e) {
        e.preventDefault();
        setToPasswordReset(true)
    }

    function goToRegister(e) {
        e.preventDefault();
        setToRegister(true)
    }

    function localize() {
        commonStrings.setLanguage(locale);
        // alertStrings.setLanguage(loc);
        // resourceStrings.setLanguage(loc);
    }

    function verifyUser(email, loc) {
        setLoading(true);

        businessApiService.verify({email: email, loc: loc})
            .then(res => {
                setAppLink(res.app_link)
                setLoading(false);
                setShowVerified(true);
            })
            .catch((e) => {
                handleNetworkError(e)
            });
    }
};

export default Login;
